<template>
  <TopBar :isConnected="isUserConnected" :owner="ownerData.owner" />
  <div id="nav"></div>
  <router-view />
</template>

<script>
import { useI18n } from "vue-i18n";

import TopBar from "@/components/TopBar.vue";
// import router from "@/router";
import { onMounted, ref } from "vue";
import OwnerService from "@/services/OwnerService";
const ownerService = new OwnerService();

/**
 * conditionner l'affichage de router-view
 * si isConnected => go to /home
 * sinon, go to /login
 */
export default {
  components: {
    TopBar,
  },
  setup() {
    const { t, locale } = useI18n();

    console.log("i18n", t("test"));

    console.log("setup bitch");
    // create data that will be passed to topbar

    // isUserConnected is a string instead of a boolean
    // it's a hack due to the way it's displayed in topbar
    const isUserConnected = ref(null);
    const ownerData = ref({});

    // on mounted, test if there is a connected and existing user
    onMounted(async () => {
      const LSOwner = localStorage.getItem("owner");
      if (LSOwner) {
        const parsedOwner = JSON.parse(LSOwner);
        const remoteOwner = await ownerService.getOwnerByid(parsedOwner.uid);
        console.log("in app.vue", remoteOwner);
        if (remoteOwner.exists) {
          // an owner is connected and exists in db
          isUserConnected.value = "yes";
          ownerData.value = remoteOwner.data;
        }
      } else {
        isUserConnected.value = "no";
      }
    });

    return {
      isUserConnected,
      ownerData,
      t,
      locale,
    };
  },
};
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
